<template>
  <!-- 院校管理 -->
  <div class="page">
    <div class="paginations" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="资源库名称：">
            <el-input size="small" v-model="searchData.zykName" placeholder="请输入资源库名称" />
          </el-form-item>
          <el-form-item label="第一主持院校：">
            <el-input size="small" v-model="searchData.firstChargeUnit" placeholder="请输入第一主持院校" />
          </el-form-item>
          <el-form-item label="项目类型：">
            <el-select size="small" v-model="projectType" clearable>
              <el-option label="国家级" value="1"></el-option>
              <el-option label="省级" value="2"></el-option>
              <el-option label="校级" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日志表：">
            <el-select size="small" v-model="logFlag" clearable>
              <el-option label="有" value="1"></el-option>
              <el-option label="无" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否纳入监测：">
            <el-select size="small" v-model="bringIntoZyk" clearable>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：">
            <el-input size="small" v-model="searchData.time" placeholder="请输入时间" />
          </el-form-item>
          <el-form-item class="btn-box">
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
            <div class="addition">
              <el-button @click="exportTable">导出<i class="h_icon el-icon-upload"></i>
              </el-button>
              <el-button @click="upload">上传<i class="h_icon el-icon-upload"></i></el-button>
              <el-button @click="add">添加<i class="h_icon icon-add"></i>
              </el-button>
              <el-button @click="checkLog">检测日志表</el-button>
              <el-button @click="createLog">生成日志表</el-button>
              <el-button @click="cutOut(true)">批量删除</el-button>
              <el-button @click="linkProfession">关联专业</el-button>
              <el-button @click="distributeKey(true)">批量下发</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="table_box">
        <el-table :data="tableObj.list" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="index" label="序号" align="center" />
          <el-table-column prop="zykNum" label="资源库编码" align="center" />
          <el-table-column prop="zykName" label="资源库名称" align="center" />
          <el-table-column prop="profession" label="专业" align="center" />
          <el-table-column prop="projectTypeCn" label="级别" align="center" />
          <el-table-column prop="bringIntoZyk" label="是否纳入监测" align="center" />
          <el-table-column prop="logTable" label="日志表" align="center" />
          <el-table-column prop="firstChargeUnit" label="第一主持院校" align="center" />
          <el-table-column prop="secondChargeUnit" label="第二主持院校" align="center" />
          <el-table-column prop="thirdChargeUnit" label="第三主持院校" align="center" />
          <el-table-column prop="buildSchoolNum" label="参建院校数" align="center">
            <template slot-scope="scope">
              <span @click="cellClick(scope.row)" style="
                  cursor: pointer;
                  text-decoration: underline;
                  color: #1bf6f8;
                ">{{ scope.row.buildSchoolNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180px">
            <template slot-scope="scope">
              <i class="icona icon-edit" title="编辑" @click="edit(scope.row)"></i>
              <i class="icona icon-delete" title="删除" @click="cutOut(false, [scope.row.id])"></i>
              <i class="icona el-icon-view" v-if="scope.row.zykid" title="查看密钥" @click="viewKey(scope.row)"></i>
              <i class="icona el-icon-document" v-else title="下发密钥" @click="distributeKey(false, [scope.row.id])"></i>
              <i class="icona el-icon-camera" title="纳入监测" @click="monitoring(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
        <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :isPageSizes="true"
          :page-size="searchData.pageDto.pageSize" :total="tableObj.total" :jumpTo="tableObj.jumpTo"
          @currentChange="search"></pageNumber>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog :title="uploadBox.title" :visible.sync="uploadBox.show" :close-on-click-modal="false" class="pop_up"
      append-to-body :before-close="handleClose" @opened="opened">
      <el-form ref="uploadBox" :model="uploadBox.data" :rules="uploadBox.rules" label-width="150px">
        <el-form-item v-for="(item, index) in formItemGroup" :key="index" :label="item.label" :prop="item.prop">
          <el-input v-if="item.option === 'input'" size="small" v-model="uploadBox.data[item.prop]"
            :placeholder="item.placeholder"></el-input>
          <el-input v-if="item.option === 'textarea'" size="small" type="textarea" v-model="uploadBox.data[item.prop]"
            :placeholder="item.placeholder"></el-input>
          <el-select v-if="item.option === 'select'" v-model="uploadBox.data[item.prop]" :placeholder="item.placeholder"
            :popper-append-to-body="false" style="width: 100%" size="small" filterable :clearable="item.clearable"
            @change="selectChange($event, item.prop)">
            <el-option v-for="(obj, i) in item.selectList" :key="i" :label="obj.name" :value="obj.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 参建院校数点击弹框 -->
    <el-dialog :title="tableDialog.title" :visible.sync="tableDialog.show" :close-on-click-modal="false" class="pop_up"
      append-to-body :before-close="tableDialogClose">
      <div class="table_box">
        <el-table :data="tableDialog.list">
          <el-table-column prop="index" label="序号" align="center" width="100" />
          <el-table-column prop="schoolName" label="学校名称" align="center" />
        </el-table>
        <pageNumber :paginations="7" :pageNum="dialogParams.pageDto.pageNum" :page-size="dialogParams.pageDto.pageSize"
          :total="tableDialog.total" :jumpTo="tableDialog.jumpTo" @currentChange="getSchoolListByZykId"></pageNumber>
      </div>
    </el-dialog>

    <el-dialog title="数据上传" width="350px" class="pop_up data-upload" append-to-body :visible.sync="dialogVisible">
      <div class="radio-box">
        <label class="name">类型：</label>
        <el-radio-group v-model="typeRadio">
          <el-radio :label="1">原版</el-radio>
          <el-radio :label="2">改版</el-radio>
        </el-radio-group>
      </div>
      <div class="addition">
        <a v-if="typeRadio === 1" class="btn-a" href="http://39.96.55.80:8766/importTemplate/lrmv2/profession_zyk.xlsx">
          模板下载
          <i class="h_icon el-icon-download"></i>
        </a>
        <a v-if="typeRadio === 2" class="btn-a" href="http://39.96.55.80:8766/importTemplate/lrmv2/profession_zyk2.xlsx">
          模板下载
          <i class="h_icon el-icon-download"></i>
        </a>
        <el-upload class="upload" action="#" :show-file-list="false" :on-change="uploadData" accept=".xls,.xlsx"
          :auto-upload="false">
          <el-button size="mini" type="primary" class="export">上传数据<i class="h_icon el-icon-upload2"></i></el-button>
        </el-upload>
      </div>
    </el-dialog>

    <el-dialog title="生成日志表" width="350px" class="pop_up data-upload" append-to-body :visible.sync="createVisible">
      <el-form :model="logForm" class="demo-form-inline" label-width="88px">
        <el-form-item label="年份：">
          <el-input size="small" v-model="logForm.year" placeholder="请输入年份" />
        </el-form-item>
        <el-form-item label="项目类型：">
          <el-select size="small" v-model="logProjectType" clearable>
            <el-option label="国家级" value="1"></el-option>
            <el-option label="省级" value="2"></el-option>
            <el-option label="校级" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="logSure">确定</el-button>
        <el-button size="small" @click="logCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      // 查询条件
      searchData: {
        zykName: "", //资源库名称
        projectType: "", //项目类型
        logFlag: "", //日志表
        bringIntoZyk: "", //是否纳入监测
        firstChargeUnit: "", //第一主持院校
        time: "", //时间
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      logFlag: "", //日志表
      projectType: "", //项目类型
      bringIntoZyk: "", //是否纳入监测
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      optId: "", //判断当前是修改还是新增操作 1-新增；2-修改
      // 新增弹窗
      uploadBox: {
        show: false,
        title: "",
        data: {
          id: null,
          zykid: "", //资源库ID
          zykNum: "", //资源库编号
          zykName: "", //资源库名称
          projectType: "", //项目类型
          projectTypeCn: "", //项目类型-中文
          professionBigClass: "", //专业大类
          professionClass: "", //专业类
          oldProfession: "", //原专业名称
          industry: "", //所属行业
          industryClass: "", //产业类
          firstChargeUnit: "", //第一主持院校
          secondChargeUnit: "", //第二主持院校
          thirdChargeUnit: "", //第三主持院校
          area: "", //地区
          sourceCollege: "", //来源院校
          collegeLevel: "", //院级
          province: "", //省份(包含省)
          province1: "", //省份(不包含省)
          platform: "", //所属平台
          webUrlStatus: "", //网址访问情况
          url: "", //资源库网址
          imgUrl: "", //资源库封面图url
        },
        rules: {},
      },
      formItemGroup: [
        {
          option: "input",
          prop: "zykid",
          label: "资源库ID",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "zykNum",
          label: "资源库编号",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "zykName",
          label: "资源库名称",
          placeholder: "请输入",
        },
        {
          option: "select",
          prop: "projectType",
          label: "项目类型",
          placeholder: "请选择",
          selectList: [
            { value: 1, name: "国家级" },
            { value: 2, name: "省级" },
            { value: 3, name: "校级" },
          ],
          clearable: true,
        },
        {
          option: "input",
          prop: "professionBigClass",
          label: "专业大类",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "professionClass",
          label: "专业类",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "profession",
          label: "专业名称",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "oldProfession",
          label: "原专业名称",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "industry",
          label: "所属行业",
          placeholder: "请输入",
        },
        {
          option: "select",
          prop: "industryClass",
          label: "产业类",
          placeholder: "请选择",
          selectList: [
            { value: "一产", name: "一产" },
            { value: "二产", name: "二产" },
            { value: "三产", name: "三产" },
          ],
          clearable: true,
        },
        {
          option: "input",
          prop: "firstChargeUnit",
          label: "第一主持院校",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "secondChargeUnit",
          label: "第二主持院校",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "thirdChargeUnit",
          label: "第三主持院校",
          placeholder: "请输入",
        },
        {
          option: "select",
          prop: "area",
          label: "地区",
          placeholder: "请选择",
          selectList: [
            { value: "东部地区", name: "东部地区" },
            { value: "中部地区", name: "中部地区" },
            { value: "西部地区", name: "西部地区" },
          ],
          clearable: true,
        },
        {
          option: "input",
          prop: "sourceCollege",
          label: "来源院校",
          placeholder: "请输入",
        },
        {
          option: "select",
          prop: "collegeLevel",
          label: "院级",
          placeholder: "请选择",
          selectList: [
            { value: "中职", name: "中职" },
            { value: "高职", name: "高职" },
            { value: "职教本科", name: "职教本科" },
            { value: "应本", name: "应本" },
          ],
          clearable: true,
        },
        {
          option: "input",
          prop: "province",
          label: "省份(包含省)",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "province1",
          label: "省份(不包含省)",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "platform",
          label: "所属平台",
          placeholder: "请输入",
        },
        {
          option: "select",
          prop: "webUrlStatus",
          label: "网址访问情况",
          placeholder: "请选择",
          selectList: [
            { value: "0", name: "正常" },
            { value: "1", name: "异常" },
          ],
          clearable: true,
        },
        {
          option: "input",
          prop: "url",
          label: "资源库网址",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "imgUrl",
          label: "资源库封面图url",
          placeholder: "请输入",
        },
      ],
      tableDialog: {
        title: "参建院校列表",
        show: false,
        list: [],
        total: 0,
        jumpTo: 1,
      },
      dialogParams: {
        zykId: "",
        pageDto: {
          pageNum: 1,
          pageSize: 10,
        },
      },
      dialogVisible: false,
      createVisible: false,
      logForm: {
        year: "",
        projectType: "",
      },
      logProjectType: "",
      selectRow: [],
      selectZykId: [],
      selectRowId: [],
      typeRadio: 1,
    };
  },
  created() {
    this.search();
  },
  mounted() {
    // 初始化
    this.uploadBox.show = false;
    this.$store.commit("modifyVague", false);
  },
  methods: {
    selectChange(value, prop) {
      if (prop !== "projectType") return;
      let projectTypeCn;
      if (value)
        projectTypeCn = this.formItemGroup
          .find((item) => item.prop === "projectType")
          .selectList.find((item) => item.value === value).name;
      else projectTypeCn = "";
      this.uploadBox.data.projectTypeCn = projectTypeCn;
    },

    // 查询表格
    search(obj = {}) {
      this.searchData.projectType = this.projectType ? this.projectType : 0;
      this.searchData.bringIntoZyk = this.bringIntoZyk ? this.bringIntoZyk : 0;
      this.searchData.logFlag = this.logFlag ? this.logFlag : -1;
      this.searchData.pageDto.pageNum = obj.page
        ? obj.page
        : this.searchData.pageDto.pageNum;
      this.tableObj.jumpTo = obj.page ? obj.page : this.tableObj.jumpTo;
      this.searchData.pageDto.pageSize = obj.limit ? obj.limit : 10;
      this.$axios
        .post(this.$apiurls.getLv2ProfessionZykInfo, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let data = res.data.list;
            for (let i = 0; i < data.length; i++) {
              if (data[i].zykid) data[i].bringIntoZyk = "是";
              else data[i].bringIntoZyk = "否";
              if (data[i].logFlag == 1) data[i].logTable = "有";
              else data[i].logTable = "无";
              if (this.searchData.pageDto.pageNum == 1) {
                data[i].index = i + 1;
              } else {
                data[i].index =
                  i +
                  1 +
                  (this.searchData.pageDto.pageNum - 1) *
                  this.searchData.pageDto.pageSize;
              }
            }
            this.tableObj.list = data;
            this.tableObj.total = res.data.total;
          }
        });
    },

    // 重置表格
    reset() {
      this.searchData.zykName = "";
      this.searchData.firstChargeUnit = "";
      this.searchData.time = "";
      this.logFlag = "";
      this.projectType = "";
      this.bringIntoZyk = "";
      this.searchData.pageDto.pageNum = 1;
      this.tableObj.jumpTo = 1;
      this.search();
    },

    // 表格多选
    handleSelectionChange(val) {
      let arr = [];
      let idArr = [];
      for (const item of val) {
        arr.push(item.zykid);
        idArr.push(item.id);
      }
      this.selectZykId = arr;
      this.selectRowId = idArr;
      this.selectRow = val;
    },

    // 参建院校数点击事件
    cellClick(item) {
      this.tableDialog.list = [];
      this.tableDialog.show = true;
      this.dialogParams.zykId = item.zykid;
      this.getSchoolListByZykId(1);
    },

    // 参建院校数点击弹框表格数据
    getSchoolListByZykId(page) {
      this.dialogParams.pageDto.pageNum = page
        ? page
        : this.dialogParams.pageDto.pageNum;
      this.tableDialog.jumpTo = page ? page : this.tableDialog.jumpTo;
      this.$axios
        .post(this.$apiurls.getSchoolListByZykId, this.dialogParams, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.list;
            let arr = [];
            for (let i = 0; i < data.length; i++) {
              let obj = {
                schoolName: data[i],
              };
              if (this.dialogParams.pageDto.pageNum == 1) {
                obj.index = i + 1;
              } else {
                obj.index =
                  i +
                  1 +
                  (this.dialogParams.pageDto.pageNum - 1) *
                  this.dialogParams.pageDto.pageSize;
              }
              arr.push(obj);
            }
            this.tableDialog.list = arr;
            this.tableDialog.total = res.data.total;
          }
        });
    },

    // 关闭参建院校弹框
    tableDialogClose() {
      this.tableDialog.show = false;
    },

    // 点击编辑按钮
    edit(row) {
      this.optId = "2";
      this.uploadBox.title = "修改三级两平台表信息";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      if (row.projectType == 0) row.projectType = "";
      for (const key in row) {
        this.uploadBox.data[key] = row[key];
      }
    },

    // 点击删除按钮
    cutOut(flag, id) {
      let str = "";
      if (flag) {
        str = "此操作将永久删除选中数据, 是否继续?";
        if (this.selectRowId.length === 0)
          return this.$message.warning({
            message: "请先选择要批量删除的行！",
          });
        id = this.selectRowId;
      } else str = "此操作将永久删除该数据, 是否继续?";
      // 批量删除
      this.$store.commit("modifyVague", true);
      this.$confirm(str, "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$axios
            .post(this.$apiurls.delLv2ProfessionZykInfo, id, {
              loading: false,
            })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "删除成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
            });
        })
        .catch(() => {
          this.uploadBox.show = false;
          this.$store.commit("modifyVague", false);
        });
    },

    // 关联专业
    linkProfession() {
      if (this.selectZykId.length === 0)
        return this.$message.warning({
          message: "请先选择要关联专业信息的行！",
        });
      this.$axios
        .post(this.$apiurls.associationMajorInfo, this.selectZykId, {
          loading: false,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "关联专业信息完成！",
              type: "success",
            });
            this.search();
          }
        });
    },

    // 查看密钥
    viewKey(item) {
      this.$axios
        .post(this.$apiurls.getZykKey, item.zykid, { loading: false })
        .then((res) => {
          if (res.code === 200) {
            this.$confirm(res.data.zykKey, "查看密钥", {
              distinguishCancelAndClose: true,
              confirmButtonText: "确定",
              cancelButtonText: "删除密钥",
            }).catch((action) => {
              if (action === "cancel")
                this.$axios
                  .post(this.$apiurls.delZykKey, item.zykid, { loading: false })
                  .then((res) => {
                    if (res.data) {
                      this.$message({
                        message: "删除密钥成功！",
                        type: "success",
                      });
                      this.search();
                    }
                  });
            });
          }
        });
    },

    // 下发密钥
    distributeKey(flag, id) {
      if (flag) {
        if (this.selectRowId.length === 0)
          return this.$message.warning({
            message: "请先选择要批量下发的行！",
          });
        id = this.selectRowId;
      }
      this.$axios
        .post(this.$apiurls.distributeZykIdKey, id, { loading: false })
        .then((res) => {
          if (res.data) {
            this.$message({
              message: "下发密钥成功！",
              type: "success",
            });
            this.search();
          }
        });
    },

    // 纳入监测
    monitoring(item) {
      this.$axios
        .post(this.$apiurls.setMonitorFlag, item.id, { loading: false })
        .then((res) => {
          if (res.data) {
            this.$message({
              message: "纳入监测成功！",
              type: "success",
            });
            this.search();
          }
        });
    },

    // 点击导出按钮
    exportTable() {
      this.searchData.projectType = this.projectType ? this.projectType : 0;
      this.searchData.bringIntoZyk = this.bringIntoZyk ? this.bringIntoZyk : 0;
      this.$axios
        .post(this.$apiurls.exportZykKeyInfo, this.searchData, {
          responseType: "blob",
          loading: false,
        })
        .then((res) => {
          if (res) {
            let blob = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            const link = document.createElement("a");
            link.download = "三级两平台管理表"; //定义表格名称，后缀是文件格式
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          }
        });
    },

    // 点击上传按钮
    upload() {
      this.dialogVisible = true;
    },

    // 上传数据
    uploadData(file) {
      let type = file.raw.type;
      if (
        type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        type !== "application/vnd.ms-excel"
      )
        return this.$message.error("请选择Excel文件进行上传！");
      const formData = new FormData(); // 声明一个FormDate对象
      formData.append("file", file.raw); // 把文件信息放入对象中
      formData.append("type", this.typeRadio); // 把文件信息放入对象中
      // 调用后台导入的接口
      this.$axios
        .post(`${this.$apiurls.importLv2ProfessionZyk}`, formData, {
          formData: true,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("导入成功");
            this.dialogVisible = false;
            this.search();
          } else {
            this.$message({
              type: "error",
              message: "导入失败",
            });
          }
        });
    },

    // 点击新增按钮
    add() {
      // 每次新增打开弹框前都先清除之前的表单数据
      for (const key in this.uploadBox.data) {
        if (key === "id") this.uploadBox.data[key] = null;
        else this.uploadBox.data[key] = "";
      }
      this.optId = "1";
      this.uploadBox.title = "添加三级两平台表信息";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
    },

    // 检测日志表
    checkLog() {
      this.$axios
        .post(this.$apiurls.saveLv2LogFlag, this.selectZykId, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: res.data,
              type: "success",
            });
            this.search();
          }
        });
    },

    // 生成日志表
    createLog() {
      let have = true;
      for (const item of this.selectZykId) {
        if (item === undefined) have = false;
      }
      if (!have) {
        this.$message({
          message: "该资源库未纳入监测，请选择已纳入监测资源库进行操作！",
          type: "warning",
        });
        return false;
      } else if (have) {
        this.logForm.year = "";
        this.logProjectType = "";
        this.createVisible = true;
      }
    },

    // 生成日志表确定
    logSure() {
      this.logForm.zykIds = this.selectZykId;
      this.logForm.projectType = this.logProjectType ? this.logProjectType : 0;
      this.$axios
        .post(this.$apiurls.initializeLogTable, this.logForm, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "生成日志表成功！",
              type: "success",
            });
            this.search();
            this.createVisible = false;
          }
        });
    },

    // 生成日志表取消
    logCancel() {
      this.createVisible = false;
    },

    // 关闭弹框
    handleClose() {
      this.uploadBox.show = false;
      this.$store.commit("modifyVague", false);
      this.optId = "";
    },

    // 添加/修改三级两平台表请求接口
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          let url =
            this.optId === "1"
              ? this.$apiurls.addLv2ProfessionZykInfo
              : this.optId === "2"
                ? this.$apiurls.editLv2ProfessionZykInfo
                : "";
          if (!url) return;
          if (this.uploadBox.data.projectType === "")
            this.uploadBox.data.projectType = 0;
          this.$axios
            .post(url, this.uploadBox.data, {
              loading: false,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: this.optId === "2" ? "编辑成功！" : "添加成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
              this.optId = "";
            });
        }
      });
    },

    // 弹框打开
    opened() {
      // 每次打开弹框都清空校验
      this.$refs.uploadBox.clearValidate();
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}

::v-deep .el-form {
  .btn-box {
    .el-form-item__content {
      display: flex;
      align-items: center;

      .search_button {
        margin-top: 0;
      }
    }
  }
}

.table_box {
  margin-bottom: 0;
}
</style>
<style lang="scss">
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;

  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;

    .el-select-dropdown__item {
      color: #fff !important;
    }

    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }

    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }

    .selected {
      color: rgba(27, 246, 248);
    }
  }

  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}

.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}

.el-icon-document,
.el-icon-camera,
.el-icon-view {
  font-size: 18px;
  color: #1bf6f8;
  margin-right: 5px;
  cursor: pointer;
}

.data-upload {
  .el-dialog {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-45%, -50%);
    background-color: #202740 !important;
  }

  .el-dialog__header {
    background: linear-gradient(to bottom,
        rgb(30, 37, 62),
        rgb(40, 47, 72)) !important;
    border-image: none !important;
  }

  .el-dialog__body {
    border-image: none !important;
  }

  .radio-box {
    text-align: center;
    margin-bottom: 20px;

    .name {
      color: #fff;
      margin-right: 10px;
    }
  }

  .el-upload {
    border: none !important;
  }

  .addition {
    display: flex;
    justify-content: center;

    .btn-a {
      height: 32px;
      line-height: 32px;
      text-decoration: none;
      padding: 0px 10px;
      display: inline-block;
      font-size: 13px;
      background-color: rgba(46, 62, 99, 0.79);
      color: #1bf6f8;
      border-radius: 4px;

      &:hover {
        transition: all 0.3s;
        color: #fff;
        border-color: #66b1ff;
        background-color: #66b1ff;
      }
    }

    button:last-child {
      margin-left: 20px;
    }
  }
}
</style>
